import { createEventEmitter } from '@/functions/utils/event-emitter'
import { EVENTS } from '@/lib/consts.ts'

type EmitterHandler = (payload?: unknown) => void

export interface EmitterApi {
  on: (name: string, handler?: EmitterHandler) => void
  off: (name: string, handler?: EmitterHandler) => void
  emit: (name: string, ...args: unknown[]) => void
  EVENTS: typeof EVENTS
}

const emitter = createEventEmitter()

const validate = (name: string): void => {
  if (!Object.values(EVENTS).includes(name)) {
    throw new Error(`Event \`${name}\` not registered!`)
  }
}

const emitterApi: EmitterApi = {
  on: (name: string, handler?: EmitterHandler): void => {
    validate(name)
    if (handler) {
      emitter.on(name, handler as (payload: unknown) => void)
    }
  },

  off: (name: string, handler?: EmitterHandler): void => {
    emitter.off(name, handler as (payload: unknown) => void | undefined)
  },

  emit: (name: string, ...args: unknown[]): void => {
    validate(name)
    emitter.emit(name, args[0])
  },

  EVENTS,
}

export const useEmitter = (): EmitterApi => {
  return emitterApi
}
